import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateService implements TranslateLoader {
  environment = environment;

  constructor(private inj: Injector) {}

  getTranslation(lang: string): Observable<any> {
    let http = this.inj.get(HttpClient);
    if (environment.retail) {
      lang = lang + '-retail';
    }
    return http.get(`./assets/i18n/${lang}.json`);
  }
}
